import { emptyArray, useFetcher, useSWRWithDefaults } from "@app/lib/swr/swr";
import type {
  ConversationBrowsedPageType,
  ConversationDetailsSkillType,
  ConversationSourceType,
  GetConversationDetailsResponseBody,
} from "@app/types/api/assistant/conversation/details";
import type { LightWorkspaceType } from "@app/types/user";
import type { Fetcher } from "swr";

export function useConversationDetails({
  conversationId,
  options,
  owner,
}: {
  conversationId?: string | null;
  options?: { disabled?: boolean };
  owner: LightWorkspaceType;
}) {
  const { fetcher } = useFetcher();
  const conversationDetailsFetcher: Fetcher<GetConversationDetailsResponseBody> =
    fetcher;

  const { data, error, mutate } = useSWRWithDefaults(
    conversationId
      ? `/api/w/${owner.sId}/assistant/conversations/${conversationId}/details`
      : null,
    conversationDetailsFetcher,
    options
  );

  return {
    sources: data?.sources ?? emptyArray<ConversationSourceType>(),
    skills: data?.skills ?? emptyArray<ConversationDetailsSkillType>(),
    browsedPages:
      data?.browsedPages ?? emptyArray<ConversationBrowsedPageType>(),
    isConversationDetailsLoading: !error && !data,
    isConversationDetailsError: error,
    mutateConversationDetails: mutate,
  };
}
